import CDialog from '01_core/components/materials/CDialog';
import ResourceHtml from '01_core/components/materials/ResourceHtml';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withRouter } from '01_core/components/system/CustomRouter';
import { DOCUMENTMNG_SEARCH, STATUS, SYSLOGIN_REVOKE } from '01_core/constants/APIs';
import { CODE } from '01_core/constants/CodeConsts';
import { LABEL } from '01_core/constants/labelConsts';
import envUtil from '01_core/logics/envUtil';
import FontSizeSetting from '13_usercustom/fontsize/FontSizeSetting';
import LanguageSetting from '13_usercustom/language/LanguageSetting';
import { STRING_CONSTS } from '01_core/constants/stringConsts';
import { TYPES_CORE_CONDITION, coreConditionActions } from '01_core/reducers/coreConditionActions';
import { TYPES_LOGIN_INFO, coreLoginInfoActions } from '01_core/reducers/coreLoginInfoActions';
import { INFOBAR_VARIANT, TYPES_INFO_BAR, coreInfoBarActions } from '01_core/reducers/coreInfoBarActions';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { MsalContext } from "@azure/msal-react";

import AppBar from '@mui/material/AppBar';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import FAQIcon from '@mui/icons-material/ChromeReaderMode';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import ManualIcon from '@mui/icons-material/LocalLibrary';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import SmartToyIcon from '@mui/icons-material/SmartToyOutlined';
import authEnvUtil, { AUTH_ENV_KEY } from '01_core/logics/authEnvUtil';

import Manual from '../manual/Manual';
import { styles } from './styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledIcon = styled('svg')(({ theme }) => stylesFromTheme(theme).icon || {});
const StyledHeaderDiv = styled('div')(({ theme }) => stylesFromTheme(theme).headerDiv || {});
const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isStaging' && prop !== 'isHyoka',
})(({ theme, isStaging, isHyoka }) => {
  const baseStyle = stylesFromTheme(theme).appBar || {};
  const stagingStyle = isStaging ? stylesFromTheme(theme).stagingMode || {} : {};
  const hyokaStyle = isHyoka ? stylesFromTheme(theme).hyokaMode || {} : {};

  return {
    ...baseStyle,
    ...stagingStyle,
    ...hyokaStyle,
  };
});
const StyledMenuButton = styled(IconButton)(({ theme }) => stylesFromTheme(theme).menuButton || {});
const StyledAppTitle = styled(Typography)(({ theme }) => stylesFromTheme(theme).appTitle || {});
const StyledGrow = styled('div')(({ theme }) => stylesFromTheme(theme).grow || {});
const StyledSectionDeskTop = styled('div')(({ theme }) => stylesFromTheme(theme).sectionDesktop || {});

export class Header extends Component {
  //表示するアイコン
  icons = {
    header_font_size: FormatSizeIcon,
    header_contact_us: MailIcon,
    common_faq: FAQIcon,
    header_manual: ManualIcon,
    header_config: SettingsIcon,
    header_aichat: SmartToyIcon,
  };
  // アクションコード2の時追加
  linkActions = {
    header_font_size: () => this.handleOpenFontSizeSetting,
    header_contact_us: () => this.handleOpenContactUs,
    header_manual: () => this.handleOpenManual,
    header_config: () => this.handleConfigOpen,
    usercustom_language: () => this.handleOpenLanguageSetting,
    header_logout: () => this.handleLogout,
    header_aichat: () => this.handleAiChat,
  };
  // お問い合わせ情報コード
  contactInfoCode = {
    siteKindCd: CODE.SITE_KIND_CD.CODE_00,
    targetCd: '00000',
    bcmKaishaSoshikiCd: '00000',
    bcpTgtJigyoCd: '000',
    documentKindCd: '000',
  };

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      isOpenFontSizeSetting: false,
      isOpenLanguageSetting: false,
      isOpenContactUs: false,
      isOpenManual: false,
      contactFileNm: '',
    };
    this._pendingAction = null;
    this.runPendingAction = this.runPendingAction.bind(this);
  }

  runPendingAction() {
    const action = this._pendingAction;
    this._pendingAction = null;
    if (typeof action === 'function') {
      action();
    }
  }

  handleConfigOpen = (event) => {
    if (document.activeElement) { document.activeElement.blur(); }
    this.setState({ anchorEl: event.currentTarget });
  };
  handleConfigClose = () => {
    this.setState({ anchorEl: null });
  };

  handleOpenManual = () => {
    if (document.activeElement) { document.activeElement.blur(); }
    this.setState({ isOpenManual: true });
  };

  handleCloseManual = () => {
    this.setState({ isOpenManual: false });
  };

  handleOpenFontSizeSetting = () => {
    if (document.activeElement) { document.activeElement.blur(); }
    this.setState({ isOpenFontSizeSetting: true });
  };
  handleCloseFontSizeSetting = () => {
    this.setState({ isOpenFontSizeSetting: false });
  };

  handleOpenLanguageSetting = () => {
    if (document.activeElement) { document.activeElement.blur(); }
    this.setState({ isOpenLanguageSetting: true });
  };
  handleCloseLanguageSetting = () => {
    this.setState({ isOpenLanguageSetting: false });
  };

  handleOpenContactUs = () => {
    const { callAPI } = this.props;
    if (document.activeElement) { document.activeElement.blur(); }
    this.setState({ isOpenContactUs: true });
    // アップロードされているファイル名の取得
    const sendData = {
      siteKindCd: this.contactInfoCode.siteKindCd,
      targetCd: this.contactInfoCode.targetCd,
      bcmKaishaSoshikiCd: this.contactInfoCode.bcmKaishaSoshikiCd,
      bcpTgtJigyoCd: this.contactInfoCode.bcpTgtJigyoCd,
      documentKindCd: this.contactInfoCode.documentKindCd,
    };
    // アップロード済みファイル情報／削除ファイル情報の取得
    callAPI(DOCUMENTMNG_SEARCH, sendData).then((response) => {
      if (response.status === STATUS.SUCCESS) {
        this.setState({
          ...this.state,
          contactFileNm: response.data.fileNm,
        });
      }
    });
  };

  handleCloseContactUs = () => {
    this.setState({ isOpenContactUs: false });
  };

  handleAiChat = () => {
    const url = this.props.systemSettings?.aichat_dify_url;
    if (!url) return;
    const win = window.open(url, '_blank', 'noopener,noreferrer');
    if (win) {
      try { win.opener = null; } catch (e) {}
    }
  };
  
  isSelfAuth() {
    const selfAuthFlg = authEnvUtil.getEnv(AUTH_ENV_KEY.SELF_AUTH_FLG);
    return selfAuthFlg === '1';
  }
  
  selfAuthLogout = async () => {
    const { callAPI, removeSessionId, clearConditions } = this.props;
      try {
        await callAPI(SYSLOGIN_REVOKE);
        removeSessionId();
        clearConditions();
      } catch (e) {
        throw new Error(e);
      }
  }
  
  handleLogout = async () => {
    const { history, checkDirty, intl, openInfoBar } = this.props;
    if (this.isSelfAuth()) {
      // 独自認証の場合
      checkDirty(async () => {
        try {
          await this.selfAuthLogout();
        } catch (e) {
          openInfoBar(INFOBAR_VARIANT.ERROR, intl.formatMessage({ id: LABEL.COMMON_LOGOUT_FAILD }));
          return e;
        }
        history.push(STRING_CONSTS.ROOT_PATH);
      });
    } else {
      // Azure AD認証の場合
      try {
        await this.selfAuthLogout();
        this.context.instance.logoutRedirect();
      } catch (e) {
        openInfoBar(INFOBAR_VARIANT.ERROR, intl.formatMessage({ id: LABEL.COMMON_LOGOUT_FAILD }));
      }
    }
  };

  contactUploadAuth = () => {
    for (var menu of this.props.menuData) {
      if (menu.fid === 'header') {
        for (var child of menu.childs) {
          if (child.fid === 'header_contact_us' && child.pms === 'upload') {
            return true;
          }
        }
      }
    }
    return false;
  };

  getAction = (fid, acd, pms) => {
    const { history } = this.props;
    if (acd === '1') {
      return () => {
        history.push('/rendering?' + fid);
      };
    }
    if (acd === '2') {
      try {
        return this.linkActions[fid](pms);
      } catch (e) {
        return () => {};
      }
    }
  };

  headerList = (menuData) => {
    const { intl, headerText } = this.props;
    return menuData.map(({ fid, acd, pms, childs }, i) => {
      const configMenu = fid === 'header_config' ? this.configMenu(childs) : undefined;     
      const Icon = this.icons[fid];
      return (
        <React.Fragment key={i}>
          <Button
            onClick={this.getAction(fid, acd, pms)}
            color='inherit'
            sx={{
              minWidth: { xs: 'auto', sm: 64 },
              px: { xs: 0.75, sm: 1 },
              mx: { xs: 0.25, sm: 0 },
              flexShrink: 0,
            }}
          >
            {Icon && (fid === 'header_aichat' ? (
              <Badge
                badgeContent='NEW!'
                overlap='circular'
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: '#ff0000',
                    color: '#fff',
                    borderRadius: '999px',
                    px: 0.75,
                    py: 0.25,
                    fontSize: '10px',
                    fontWeight: 700,
                    lineHeight: 1,
                    minWidth: 'auto',
                    height: 'auto',
                    transform: 'translate(35%, -115%)',
                    pointerEvents: 'none',
                  },
                }}
              >
                <StyledIcon as={Icon} />
              </Badge>
            ) : <StyledIcon as={Icon} />)}
            {headerText ? intl.formatMessage({ id: 'menu.' + fid }) : null}
          </Button>
          {configMenu}
        </React.Fragment>
      );
    });
  };

  configMenu = (settingData) => {
    const { intl } = this.props;
    return (
      <Menu
        anchorEl={this.state.anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(this.state.anchorEl)}
        onClose={this.handleConfigClose}
        TransitionProps={{ onExited: this.runPendingAction }}
      >
        {settingData.map(({ fid, acd, pms }, i) => {
          return (
            <MenuItem
              key={i}
              onClick={(e) => {
                if (e && e.currentTarget && typeof e.currentTarget.blur === 'function') {
                  e.currentTarget.blur();
                }
                const action = this.getAction(fid, acd, pms);
                this._pendingAction = action;
                this.handleConfigClose();
              }}
            >
              {intl.formatMessage({ id: 'menu.' + fid })}
            </MenuItem>
          );
        })}
      </Menu>
    );
  };

  setContactFileNm = (obj) => {
    this.setState({
      ...this.state,
      contactFileNm: obj.fileNm,
    });
  };

  render() {
    const { intl, menuData, handleMenuChange, closeMenuBar } = this.props;
    const { isOpenContactUs, isOpenFontSizeSetting, isOpenLanguageSetting, isOpenManual } =
      this.state;

    let headerData = menuData ? menuData.filter((menu) => menu.fid === 'header') : undefined;
    headerData = headerData && headerData.length === 1 ? headerData[0] : undefined;

    return (
      <StyledHeaderDiv>
        <CssBaseline />
        <StyledAppBar
          position='fixed'
          color={'primary'}
          isStaging={envUtil.isStaging()}
          isHyoka={envUtil.isHyoka()}
        >
          <Toolbar
            sx={{
              minHeight: { xs: 56, sm: 56 },
              py: 0,
            }}
          >
            <StyledMenuButton
              color='inherit'
              aria-label='Open drawer'
              onClick={handleMenuChange}
            >
              <MenuIcon />
            </StyledMenuButton>
            <StyledAppTitle
              variant='h5'
              color='inherit'
              noWrap
              onClick={() => {
                this.props.history.push('/rendering?');
                closeMenuBar();
              }}
            >
              {intl.formatMessage({ id: LABEL.CORE_ONE_NEC })}
            </StyledAppTitle>
            <StyledGrow />
            <StyledSectionDeskTop>
              {headerData && this.headerList(headerData.childs)}
              <CDialog
                open={isOpenContactUs}
                title={intl.formatMessage({ id: LABEL.CORE_CONTACT_US })}
                handleClose={this.handleCloseContactUs}
                fullWidth={false}
              >
                <DialogContent sx={{ marginTop: 2 }}>
                  <ResourceHtml id='contact_us'></ResourceHtml>
                </DialogContent>
              </CDialog>
              <CDialog
                open={isOpenManual}
                title={intl.formatMessage({ id: LABEL.CORE_MANUAL })}
                handleClose={this.handleCloseManual}
                fullWidth={false}
              >
                <DialogContent sx={{ marginTop: 2 }}>
                  <Manual />
                </DialogContent>
              </CDialog>
            </StyledSectionDeskTop>
            <FontSizeSetting open={isOpenFontSizeSetting} handleClose={this.handleCloseFontSizeSetting} />
            <LanguageSetting open={isOpenLanguageSetting} handleClose={this.handleCloseLanguageSetting} />
          </Toolbar>
        </StyledAppBar>
      </StyledHeaderDiv>
    );
  }
}

const mapStateToProps = (state) => ({
  menuData: state.coreLoginInfo.menuData,
  systemSettings: state.coreLoginInfo.systemSettings
});

const mapDispatchToProps = (dispatch) => {
  return {
    openInfoBar: (type, message) => dispatch(coreInfoBarActions[TYPES_INFO_BAR.OPEN](type, message)),
    removeSessionId: () => dispatch(coreLoginInfoActions[TYPES_LOGIN_INFO.REMOVE_SESSION_ID]()),
    clearConditions: () => dispatch(coreConditionActions[TYPES_CORE_CONDITION.CLEAR]()),
  };
};

Header.contextType = MsalContext;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(withCallAPI(Header))));